import React from 'react';
import { Hourglass } from 'lucide-react';
import SubModal from './SubModal';

/**
 * Props:
 *  - show           {bool}
 *  - onClose        {function}  "Remind Me Later" / backdrop / X
 *  - expiryDate     {string}    e.g. "18/08/2026"
 *  - onRenewNow     {function}
 */
const SubscriptionExpiringModal = ({ show, onClose, expiryDate, onRenewNow }) => (
  <SubModal show={show} onClose={onClose}>
    <div className="sub-icon-wrap warn">
      <Hourglass size={26} />
      
    </div>
    <h3 className="sub-modal-title">Subscription Expiring Soon</h3>
    <p className="sub-modal-text">Renew in advance to avoid service interruption.</p>

    <div className="sub-info-box">
      <span className="sub-info-label">Expiry Date</span>
      <span className="sub-info-value">{expiryDate}</span>
    </div>

    <div className="sub-actions">
      <button
        type="button"
        className="btn bg-dg c-w fw-semibold py-2"
        onClick={() => { onRenewNow?.(); onClose?.(); }}
      >
        Renew Now
      </button>
      <button type="button" className="sub-btn-ghost" onClick={onClose}>
        Remind Me Later
      </button>
    </div>
  </SubModal>
);

export default SubscriptionExpiringModal;
